import * as Ord from 'fp-ts/Ord';
import { SelectItem } from '@mantine/core';
import * as S from 'fp-ts/string';

export const selectItemOrd = Ord.fromCompare<SelectItem>((x, y) =>
  S.Ord.compare(x.label ?? x.value, y.label ?? y.value),
);
